import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const isPrerender = (): boolean =>
  getGlobalProperty<Navigator>("navigator")
    ?.userAgent?.toLowerCase()
    .includes("prerender") || getGlobalProperty<boolean>("isPrerender", false);
